module.exports = __webpack_public_path__ + "static/certificate2-41bad52cbf8ed012ff0aae97d0b80398.jpg";